import React from "react";
import "./uniformLoader.css";

const UniformLoader = ({ 
  title = "Loading...", 
  message = "Please wait while we process your request", 
  subMessage = "This may take a few moments",
  isFullPage = true,
  fullPage = false // Support both prop names for compatibility
}) => {
  // Support both prop names
  const showFullPage = isFullPage || fullPage;
  
  const loaderContent = (
    <div className="bg-white rounded-2xl p-8 sm:p-12 flex flex-col items-center justify-center shadow-2xl max-w-md mx-4">
      <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-600 border-t-transparent mb-6"></div>
      <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">{title}</h3>
      <p className="text-sm sm:text-base text-gray-600 text-center">{message}</p>
      {subMessage && (
        <p className="text-xs text-gray-500 mt-2 text-center">{subMessage}</p>
      )}
    </div>
  );

  if (showFullPage) {
    return (
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center"
        style={{ 
          zIndex: 99999, // Very high z-index for iframe compatibility
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }}
      >
        {loaderContent}
      </div>
    );
  }

  return loaderContent;
};

export default UniformLoader;
